import gql from 'graphql-tag';
import { isolateComponent } from '@zapier/style-encapsulation';
import { daysFromNow, parseDateTime } from '@zapier/date';
import { Price } from '@zapier/currency';
import { Alert } from '@zapier/design-system';
export const shouldRender = (data) => {
    return data.currentAccount.isTrialingTeams;
};
export const setTeamAutoUpgradeMutation = gql `
  mutation setTeamAutoUpgrade($accountId: Int!, $shouldAutoUpgrade: Boolean!) {
    setTeamAutoUpgrade(id: $accountId, shouldAutoUpgrade: $shouldAutoUpgrade) {
      id
      teamsTrialAutoUpgrade
    }
  }
`;
const getAutoUpgradeButtonText = ({ error, loading, willAutoUpgrade, }) => {
    if (loading) {
        return willAutoUpgrade
            ? 'Disabling auto-upgrade…'
            : 'Enabling auto-upgrade…';
    }
    if (error) {
        return willAutoUpgrade
            ? 'Error disabling auto-upgrade…'
            : 'Error enabling auto-upgrade…';
    }
    return willAutoUpgrade ? 'Disable auto-upgrade' : 'Enable auto-upgrade';
};
export const Component = function TeamsTrialing(props) {
    var _a, _b;
    const { data, currency } = props;
    const { currentAccount } = data;
    const willAutoUpgrade = currentAccount.teamsTrialAutoUpgrade;
    const canToggleAutoUpgrade = ['owner', 'admin'].includes(currentAccount.currentUserRole);
    const nextPlanAmount = (_b = (_a = data.nextTeamPlan) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : -1;
    const interval = currentAccount.plan.interval;
    const isYearly = interval === 'year';
    const monthlyAmount = isYearly ? nextPlanAmount / 12 : nextPlanAmount;
    const trialDaysRemaining = currentAccount.teamTrialEndDate
        ? daysFromNow(currentAccount.teamTrialEndDate)
        : 0;
    const defaultMutationReturnData = {
        id: currentAccount.id,
        teamsTrialAutoUpgrade: currentAccount.teamsTrialAutoUpgrade,
    };
    const [toggleTeamAutoUpgrade, { error, loading }] = props.useMutation(setTeamAutoUpgradeMutation, {
        update: (cache, { data: respData = defaultMutationReturnData }) => {
            cache.modify({
                id: cache.identify(respData),
                fields: {
                    teamsTrialAutoUpgrade() {
                        return respData.teamsTrialAutoUpgrade;
                    },
                },
            });
        },
    });
    const onToggleAutoUpgrade = () => {
        toggleTeamAutoUpgrade({
            variables: {
                accountId: currentAccount.id,
                shouldAutoUpgrade: !willAutoUpgrade,
            },
        });
    };
    const autoUpgradeToggle = canToggleAutoUpgrade && (isolateComponent("button", { type: "button", css: { textDecoration: 'underline' }, onClick: onToggleAutoUpgrade }, getAutoUpgradeButtonText({ error, loading, willAutoUpgrade })));
    const daysText = trialDaysRemaining === 1 ? 'day' : 'days';
    const title = `${trialDaysRemaining} ${daysText} left in your Team trial`;
    const formattedEndDate = parseDateTime(currentAccount.teamTrialEndDate)
        .toLocaleString(undefined, { month: 'short', day: 'numeric' })
        .replace(/([a-z]+)/i, '$1.');
    const intervalText = isYearly ? '(paid annually)' : '';
    const content = willAutoUpgrade ? (isolateComponent("p", null,
        `On ${formattedEndDate}, you’ll be automatically upgraded and charged `,
        monthlyAmount < 0 ? ('') : (isolateComponent("span", null,
            isolateComponent(Price, { currency: currency }, monthlyAmount),
            "/month",
            ' ',
            intervalText.trim())),
        ' ',
        autoUpgradeToggle)) : (isolateComponent("p", null,
        `On ${formattedEndDate}, you’ll lose access to Team features. `,
        autoUpgradeToggle,
        " ",
        'to stay on the Team plan when your trial ends'));
    return (isolateComponent(Alert, { layout: props.layout, title: title, type: "info" }, content));
};
//# sourceMappingURL=TeamsTrialing.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
